import {
    SYSTEM_SUBMIT_POSITIONTYPE_BEGIN,
    SYSTEM_SUBMIT_POSITIONTYPE_SUCCESS,
    SYSTEM_SUBMIT_POSITIONTYPE_FAILURE,
    SYSTEM_SUBMIT_POSITIONTYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitPositionType(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_POSITIONTYPE_BEGIN,
      });
  
      let apiurl = '/api/b/positionType/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/positionType/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_POSITIONTYPE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_POSITIONTYPE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitPositionTypeError() {
    return {
      type: SYSTEM_SUBMIT_POSITIONTYPE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_POSITIONTYPE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitPositionTypePending: true,
          submitPositionTypeError: null,
        };
  
      case SYSTEM_SUBMIT_POSITIONTYPE_SUCCESS:
        // The request is success
        return {
          ...state,
          submitPositionTypePending: false,
          submitPositionTypeError: null,
        };
  
      case SYSTEM_SUBMIT_POSITIONTYPE_FAILURE:
        // The request is failed
        return {
          ...state,
          submitPositionTypePending: false,
          submitPositionTypeError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_POSITIONTYPE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitPositionTypeError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitPositionType.js